(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name cabinFlightIssues.controller:CabinFlightIssuesCtrl
	 *
	 * @description
	 *
	 */
	angular.module('cabinFlightIssues').controller('CabinFlightIssuesCtrl',
			CabinFlightIssuesCtrl);

	function CabinFlightIssuesCtrl(CommonMasterData, $sce, CommonLogicService) {
		var vm = this;
		vm.ctrlName = 'CabinFlightIssuesCtrl';

		vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				department : null,
				crewId : null
			},
			masterList : {
				departmentList : [],
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false,
				fromDateAfterToDate : false,
				isToDateFutureDate : false
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl : null
		};

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
			searchCabinFlightIssues(params);
		};

		// on change search field
		vm.changeSearchField = function(searchParams, flag) {
			setDateValidationFlags();
			if (!vm.model.masterList.toDateFormatInvalid
					&& !vm.model.masterList.fromDateFormatInvalid
					&& !vm.model.masterList.isToDateFutureDate) {
				if (istoDateBeforeFromDate()) {
					vm.model.masterList.fromDateAfterToDate = true;
				} else {
					vm.model.masterList.fromDateAfterToDate = false;
				}
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
			}
		};

		function setDateValidationFlags() {
			// if from date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
				vm.model.masterList.fromDateFormatInvalid = true;
			} else {
				vm.model.masterList.fromDateFormatInvalid = false;
			}

			// if to date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
				vm.model.masterList.toDateFormatInvalid = true;
				vm.model.masterList.isToDateFutureDate = false;
			} else {
				vm.model.masterList.toDateFormatInvalid = false;
				if (!!vm.model.searchCriteria.toDate) {
					vm.model.masterList.isToDateFutureDate = istoDateFutureDate();
				} else {
					vm.model.masterList.isToDateFutureDate = false;
				}
			}
		}

		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}

		// check from date and to date
		function istoDateBeforeFromDate() {
			return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
					.isBefore(
							moment(vm.model.searchCriteria.fromDate,
									"DD/MM/YYYY"));
		}
		;

		// check to date is a future date
		function istoDateFutureDate() {
			return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
					.isAfter(moment().toDate());
		}
		;

		// search Cabin Flight Issues Report
		function searchCabinFlightIssues(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;
				var url = CommonLogicService.getReportUrl(
						'cabin_flight_issues.rptdesign',
						getSearchParamMap(param));
				vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
			}
		}

		// set search param map
		function getSearchParamMap(param) {
			var searchParamMap = {};
			searchParamMap["fromDate"] = param.fromDate;
			searchParamMap["toDate"] = param.toDate;
			if (!!param.department && !!param.department.code) {
				searchParamMap["department"] = param.department.code;
			}
			if (!!param.crewId) {
				searchParamMap["crewId"] = param.crewId;
			}
			return searchParamMap;
		}

		function isValidSearchParams(params) {
			setDateValidationFlags();
			// if date invalid
			if (vm.model.masterList.toDateFormatInvalid
					|| vm.model.masterList.fromDateFormatInvalid
					|| vm.model.masterList.isToDateFutureDate) {
				return false;
			} else if (istoDateBeforeFromDate()) {
				vm.model.masterList.fromDateAfterToDate = true;
				return false;
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
				return true;
			}
		}

		(function() {
			// load departments
			CommonMasterData.getDepartments(function(departmentList) {
				vm.model.masterList.departmentList = departmentList;
			}, function() {
				console.log('Department list retrieval error');
			});

		})();
	}
}());
